import { render } from "./iuf-select.vue?vue&type=template&id=120775bd&scoped=true&ts=true"
import script from "./iuf-select.vue?vue&type=script&lang=ts"
export * from "./iuf-select.vue?vue&type=script&lang=ts"

import "./iuf-select.vue?vue&type=style&index=0&id=120775bd&lang=scss&scoped=true"
import "./iuf-select.vue?vue&type=style&index=1&id=120775bd&lang=scss"
/* custom blocks */
import block0 from "./i18n/messages.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc3593438386%2Fsrc%2Fpadme-ui-aws%2Fapps%2Fmain%2Fsrc%2Fcomponents%2Fselect%2Fiuf-select.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120775bd"]])

export default __exports__